export default "__VITE_ASSET__DJ_JPMDb__"